import { utils } from "./utils.js";

var getOneZero = function(value) {
    if (value) {
        return 1;
    }

    return 0;
};

var getMonths = function(insuranceLengthValue) {
    if (insuranceLengthValue === "LessThanSixMonths") {
        return 0;
    }
    if (insuranceLengthValue === "SixMonthsOrMore") {
        return 6;
    }

    return 12;
};

var getGender = function(genderValue) {
    if (genderValue === "Male") {
        return "M";
    }
    if (genderValue === "Female") {
        return "F";
    }

    return "X";
};

var getMaritalStatus = function(isMarried) {
    if (isMarried) {
        return "Married";
    }

    return "Single";
};

var getCreditRating = function(creditRatingValue) {
    if (creditRatingValue === "BelowAverage") {
        return "Below Average";
    }
    if (creditRatingValue === "Okay") {
        return "Average";
    }

    return creditRatingValue;
};

var getVehicles = function(vehicleValues) {
    var vehicles = [];

    for(var i = 0; vehicleValues && i < vehicleValues.length; i++) {
        var vehicleValue = vehicleValues[i];

        var vehicle = {
            year: vehicleValue.year,
            make: vehicleValue.make,
            model: vehicleValue.model,
            submodel: vehicleValue.trim
        }
        vehicles.push(vehicle);
    }

    return vehicles;
};

var formatPhoneNumber = function(phoneNumberValue) {

    // strip non-numeric characters
    var phoneNumber = phoneNumberValue.replace(/\D/g, "");

    if (phoneNumber.length != 10) {
        return null;
    }

    return "(" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4);
}

var mediaAlphaUtils = {
    getDataQueryStringParameterValue: function(startTime, lead, jornayaId, tcpaText) {
        try {
            var finishTime = new Date();
            var monthsInsured = getMonths(lead.insuranceLength);
            var name = lead.firstName + " " + lead.lastName;
            var dateOfBirth = lead.dateOfBirthYear + "-" + lead.dateOfBirthMonth + "-" + lead.dateOfBirthDay;

            var vehicles = getVehicles(lead.vehicles);
            var drivers = [
                {
                    driver: name,
                    gender: getGender(lead.gender),
                    marital_status: getMaritalStatus(lead.isMarried),
                    birth_date: dateOfBirth,
                    credit_rating: getCreditRating(lead.creditRating),
                    sr_22: getOneZero(lead.needsSr22)
                }
            ];

            var data = {
                contact: name,
                email: lead.email,
                phone: formatPhoneNumber(lead.phoneNumber),
                address: lead.streetAddress,
                zip: lead.zipCode,
                home_ownership: getOneZero(lead.currentResidenceType == "Own"),
                vehicles: vehicles,
                drivers: drivers,
                currently_insured: getOneZero(lead.isInsured),
                current_company: lead.currentInsurer,
                current_customer: monthsInsured,
                continuous_coverage: monthsInsured,
                //military_affiliation: getOneZero(lead.isInMilitary),
                leadid_id: jornayaId ? jornayaId.value : null,
                tcpa: {
                    call_consent: 1,
                    sms_consent: 1,
                    text: tcpaText,
                    //url:
                },
                meta: {
                    form_begin: startTime.toISOString(),
                    form_submit: finishTime.toISOString()
                }
            };

            utils.log(data);

            var dataJson = JSON.stringify(data);
            utils.log(dataJson);

            var dataJsonBase64Encoded = btoa(dataJson);
            utils.log(dataJsonBase64Encoded);

            return dataJsonBase64Encoded;
        }
        catch (err) {
            // ignore
            utils.log(err);
        }

        return null;
    }
};

export { mediaAlphaUtils }
